import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=d596d70c&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d596d70c')) {
      api.createRecord('d596d70c', component.options)
    } else {
      api.reload('d596d70c', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=d596d70c&", function () {
      api.rerender('d596d70c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-230n7phGQOPEg/JS/comp/DateRangeExt.vue"
export default component.exports